import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export enum MediaType {
    MEDIA_TYPE_UNSET = 0,
    IMAGE = 1,
    VIDEO = 2,
    GIF = 3,
    AUDIO = 4,
    UNRECOGNIZED = -1
}
export interface MediaSignals {
    mediaDurationMs: number;
    mediaType: MediaType;
}
function createBaseMediaSignals(): MediaSignals {
    return { mediaDurationMs: 0, mediaType: 0 };
}
export const MediaSignals: MessageFns<MediaSignals> = {
    encode(message: MediaSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.mediaDurationMs !== 0) {
            writer.uint32(8).uint32(message.mediaDurationMs);
        }
        if (message.mediaType !== 0) {
            writer.uint32(16).int32(message.mediaType);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): MediaSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMediaSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.mediaDurationMs = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.mediaType = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<MediaSignals>, I>>(base?: I): MediaSignals {
        return MediaSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<MediaSignals>, I>>(object: I): MediaSignals {
        const message = createBaseMediaSignals();
        message.mediaDurationMs = object.mediaDurationMs ?? 0;
        message.mediaType = object.mediaType ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
